export default "__VITE_ASSET__BjecUylQ__"